import { Navigate, useLocation } from "react-router";

/** `/tracker` → `/trackers` with the query string intact (the old spelling:
 *  keeps every bookmark and link alive). */
export const TrackerRedirect = () => {
  const { search } = useLocation();
  return <Navigate to={{ pathname: "/trackers", search }} replace />;
};
